import { useState, useEffect } from 'react';
import { Box, Button, ButtonGroup, FormLabel, HStack, IconButton } from '@chakra-ui/react';

import CustomValidationControl from './CustomValidationControl';

import { HelpButton, HelpButtonProps } from './HelpButton';

import { FaTrashAlt } from 'react-icons/fa';

interface DateTimePickerProps {
    maxPickers: number;
    name: string;
    onChange: any;
    value: any;
    label?: string;
    title?: string;
    help?: HelpButtonProps;
    [x: string]: any;
}

export const DateTimePickerChain = ({
    maxPickers,
    onChange,
    value,
    label,
    help,
    title,
    ...rest
}: DateTimePickerProps) => {
    const [pickers, setPickers] = useState<Date[]>([new Date()]);

    useEffect(() => {
        if (!value) {
            return;
        }
        setPickers(value);
    }, [value, setPickers]);

    const handleAddPicker = () => {
        const pickersCount = pickers.length;
        const newDate = new Date();
        if (pickersCount < maxPickers) {
            setPickers([...pickers, newDate]);
            onChange(pickersCount, newDate);
        }
    };

    const handlePickerChange = (index: number, date: Date) => {
        if (date !== null) {
            const newPickers = [...pickers];
            newPickers[index] = date;
            setPickers(newPickers);
            onChange(index, date);
        }
    };

    const handleRemovePicker = (index: number) => {
        const newPickers = [...pickers];
        newPickers.splice(index, 1);
        setPickers(newPickers);
        onChange(index, null);
    };

    return (
        <Box>
            <FormLabel>
                {title}
                {help && <HelpButton ml="2" {...help}></HelpButton>}
            </FormLabel>
            {pickers.map((picker, index) => (
                <HStack key={index} spacing={4} mt={3}>
                    <CustomValidationControl
                        type="datetime"
                        name={`timeframes.manual.start_date_${index}`}
                        onChange={() => {}}
                        onDateChange={(date) => handlePickerChange(index, date)}
                        value={picker}
                        label={label}
                        isRequired={true}
                        validationMessage={rest.validationMessage}
                    ></CustomValidationControl>
                    {index > 0 && (
                        <IconButton
                            aria-label="Remove Date"
                            onClick={() => handleRemovePicker(index)}
                            icon={<FaTrashAlt />}
                        >
                            Remove
                        </IconButton>
                    )}
                </HStack>
            ))}
            {pickers.length < maxPickers && (
                <ButtonGroup mt="3">
                    <Button onClick={handleAddPicker}>Add Date</Button>
                </ButtonGroup>
            )}
        </Box>
    );
};
